// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.bs.js");
var PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.bs.js");
var PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.bs.js");
var PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.bs.js");

var convertFragment = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.Utils.localDraftGeocodingStatus_decode;

var FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

var FormStateFragment_localDraftMlsStatus_decode = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.Utils.localDraftMlsStatus_decode;

var FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardFormRelayValidatorsKeyFactsAddressStreetAddress_formState_graphql.Utils.localDraftMlsStatus_fromString;

var FormStateFragment = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function useIsValid(draft, formState) {
  var draft$1 = use(draft);
  var formState$1 = use$1(formState);
  var match = PropertyWizardFormRelay.Context.use();
  var mode = match.mode;
  var match$1 = PropertyWizardRelayUtils.FormUtils.noneIfEmpty(draft$1.draftProperty.address);
  var match$2 = draft$1.draftProperty.selectedArea;
  var match$3 = formState$1.geocodingStatus;
  var match$4 = formState$1.mlsStatus;
  var exit = 0;
  if (match$1 === undefined) {
    return {
            NAME: "Invalid",
            VAL: "missingAddress"
          };
  }
  if (match$2 === undefined) {
    return {
            NAME: "Invalid",
            VAL: "missingCity"
          };
  }
  var label = match$2.label;
  switch (match$3) {
    case "Valid" :
        switch (match$4) {
          case "OnMls" :
              if (mode !== "New") {
                return {
                        NAME: "Valid",
                        VAL: [
                          match$1,
                          label
                        ]
                      };
              }
              exit = 1;
              break;
          case "NotOnMls" :
          case "OnMlsButAllowed" :
              return {
                      NAME: "Valid",
                      VAL: [
                        match$1,
                        label
                      ]
                    };
          default:
            exit = 1;
        }
        break;
    case "Error" :
        return {
                NAME: "Invalid",
                VAL: "geocodingFailed"
              };
    default:
      exit = 1;
  }
  if (exit === 1) {
    var exit$1 = 0;
    switch (match$3) {
      case "ErrorDuplicateListing" :
          return {
                  NAME: "Invalid",
                  VAL: "duplicateListing"
                };
      case "ErrorOutsideChapterBoundaries" :
          return {
                  NAME: "Invalid",
                  VAL: "outsideChapterBoundaries"
                };
      default:
        if (match$4 === "OnMls") {
          if (mode === "New") {
            return {
                    NAME: "Invalid",
                    VAL: "propertyAlreadyOnMls"
                  };
          }
          exit$1 = 2;
        } else {
          exit$1 = 2;
        }
    }
    if (exit$1 === 2) {
      if (match$4 === "Error") {
        return {
                NAME: "Invalid",
                VAL: "mlsStatusCheckFailed"
              };
      } else {
        return ;
      }
    }
    
  }
  
}

var StreetAddress = {
  DraftFragment: DraftFragment,
  FormStateFragment: FormStateFragment,
  useIsValid: useIsValid
};

var convertFragment$2 = PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_draft_graphql.node, convertFragment$2, fRef);
}

var DraftFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

var convertFragment$3 = PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.node, convertFragment$3, fRef);
}

var FormStateFragment_localDraftGeocodingStatus_decode$1 = PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.Utils.localDraftGeocodingStatus_decode;

var FormStateFragment_localDraftGeocodingStatus_fromString$1 = PropertyWizardFormRelayValidatorsKeyFactsAddressCityOrZip_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

var FormStateFragment$1 = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode$1,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString$1,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function useIsValid$1(draft, formState) {
  var draft$1 = use$2(draft);
  var formState$1 = use$3(formState);
  var match = draft$1.draftProperty.selectedArea;
  var match$1 = formState$1.geocodingStatus;
  if (match === undefined) {
    if (match$1 === "Called") {
      return ;
    } else {
      return {
              NAME: "Error",
              VAL: "is required"
            };
    }
  }
  switch (match$1) {
    case "NotCalled" :
    case "Called" :
        return ;
    case "Valid" :
        return "Valid";
    default:
      return {
              NAME: "Error",
              VAL: ""
            };
  }
}

var CityOrZip = {
  DraftFragment: DraftFragment$1,
  FormStateFragment: FormStateFragment$1,
  useIsValid: useIsValid$1
};

var convertFragment$4 = PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddress_draft_graphql.node, convertFragment$4, fRef);
}

var DraftFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

var convertFragment$5 = PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayValidatorsKeyFactsAddress_formState_graphql.node, convertFragment$5, fRef);
}

var FormStateFragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function useIsValid$2(draft, formState) {
  var draft$1 = use$4(draft);
  var formState$1 = use$5(formState);
  var isStreetAddressValid = useIsValid(draft$1.fragmentRefs, formState$1.fragmentRefs);
  var isCityOrZipValid = useIsValid$1(draft$1.fragmentRefs, formState$1.fragmentRefs);
  if (isStreetAddressValid !== undefined && typeof isStreetAddressValid === "object" && isStreetAddressValid.NAME === "Invalid") {
    return "Invalid";
  }
  if (isCityOrZipValid !== undefined && typeof isCityOrZipValid === "object" && isCityOrZipValid.NAME === "Error") {
    return "Invalid";
  } else {
    return "Valid";
  }
}

var FormUtils;

exports.FormUtils = FormUtils;
exports.StreetAddress = StreetAddress;
exports.CityOrZip = CityOrZip;
exports.DraftFragment = DraftFragment$2;
exports.FormStateFragment = FormStateFragment$2;
exports.useIsValid = useIsValid$2;
/* RescriptRelay_Fragment Not a pure module */
